import Vue from 'vue'
import VueRouter from 'vue-router'

// import store from './store'
// import Login from '../components/Login.vue'
// import Home from '../components/Home.vue'
// import Welcome from '../components/Welcome.vue'

// import Users from '../components/user/Fence.vue'
// import Rights from '../components/power/Rights.vue'
// import Roles from '../components/power/Roles.vue'

// import Cate from '../components/goods/Cate.vue'
// import Params from '../components/goods/Params.vue'

// import GoodsList from '../components/goods/Device.vue'
// import Add from '../components/goods/Add.vue'

// import Order from '../components/order/Order.vue'
// import Report from '../components/report/Report.vue'

// 路由懒加载
const Login = () => import(/* webpackChunkName: "Login_Home_Welcome" */ '../components/Login.vue')
const Home = () => import(/* webpackChunkName: "Login_Home_Welcome" */ '../components/Home.vue')
const Welcome = () => import(/* webpackChunkName: "Login_Home_Welcome" */ '../components/Welcome.vue')


const Users = () => import(/* webpackChunkName: "Users_Rights_Roles" */ '../components/user/User.vue')
const UserBind = () => import(/* webpackChunkName: "Users_Rights_Roles" */ '../components/gpsUser/userBind/UserBind.vue')
const UserList = () => import(/* webpackChunkName: "Users_Rights_Roles" */ '../components/gpsUser/userList/List.vue')
const DeviceList = () => import(/* webpackChunkName: "Users_Rights_Roles" */ '../components/device/deviceList/Device.vue')
const DeviceFence = () => import(/* webpackChunkName: "Users_Rights_Roles" */ '../components/device/deviceFence/Fence.vue')
const PortConfig = () => import(/* webpackChunkName: "Users_Rights_Roles" */ '../components/device/deviceList/PortConfig')
const Dept = () => import(/* webpackChunkName: "Users_Rights_Roles" */ '../components/dept/Dept.vue')
const Code = () => import(/* webpackChunkName: "Users_Rights_Roles" */ '../components/code/Code.vue')
const Customer = () => import('../components/customer/Customer')
const Tracking = () => import(/* webpackChunkName: "Users_Rights_Roles" */ '../components/device/tracking')
const History = () => import('../components/device/history')
const AlterReport = () => import('../components/report/alterReport')
const SpeedReport = () => import('../components/report/speedReport')
const OdometerReport = () => import('../components/report/odometerReport')
const BikeReport = () => import('../components/report/bikeReport')
const HistoryReport = () => import('../components/report/historyReport')
const StopReport = () => import('../components/report/stopReport')
const OilReport = () => import('../components/report/oilReport')
const ReportMain = () => import('../components/report/reportMain')
const CircularFence = () => import('../components/device/deviceFence/circularFence')
const PolygonalFence = () => import('../components/device/deviceFence/polygonalFence')
const SystemMain = () => import('../components/system/systemMain')

const SysLog = () => import('../components/sysLog/Log.vue')

const DeviceAlarm = () => import('../components/alarm/Alarm.vue')

Vue.use(VueRouter)

/*const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to){
  return VueRouterPush.call(this,to).catch(err => err )
}*/

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login },
  { path: '/device/tracking', component: Tracking },
  { path: '/device/historicalTrack', component: History },
  { path: '/device/circularFence', component: CircularFence },
  { path: '/device/polygonalFence', component: PolygonalFence },

  { path: '/home',
    component: Home,
    redirect: '/Welcome',
    // redirect: '/device/deviceList',
    children: [
      { path: '/home', component: Welcome },
      { path: '/system/users', component: Users },
      { path: '/system/dept', component: Dept },
      { path: '/system/log', component: SysLog },
      { path: '/system/code', component: Code },
      { path: '/system/customer', component: Customer },
      { path: '/gpsUser/userBind', component: UserBind },
      { path: '/gpsUser/userList', component: UserList },
      { path: '/device/deviceList', component: DeviceList },
      { path: '/device/alarm', component: DeviceAlarm },
      { path: '/device/deviceFence', component: PolygonalFence },
      { path: '/device/portConfig', name: 'portConfig', component: PortConfig },
      { path: '/device/deviceStatistic/reportMain',

        component: ReportMain,
        redirect: '/device/deviceStatistic/odometerReport',
        children: [
          { path: '/device/deviceStatistic/alterReport', component: AlterReport },
          { path: '/device/deviceStatistic/speedReport', component: SpeedReport },
          { path: '/device/deviceStatistic/odometerReport', component: OdometerReport },
          { path: '/device/deviceStatistic/bikeReport', component: BikeReport },
          { path: '/device/deviceStatistic/historyReport', component: HistoryReport },
          { path: '/device/deviceStatistic/stopReport', component: StopReport },
          { path: '/device/deviceStatistic/oilReport', component: OilReport }
        ]
      },
      { path: '/system/systemMain',
        component: SystemMain,
        redirect: '/system/sub/users',
        children: [
          { path: '/system/sub/users', component: Users },
          { path: '/system/sub/dept', component: Dept },
          { path: '/system/sub/customer', component: Customer }
        ]
      }
    ] }

]

const router = new VueRouter({
  routes
})

// 挂载路由导航守卫,to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作 next('/login')强制跳转login
router.beforeEach((to, from, next) => {
  // 访问登录页，放行
  if (to.path === '/login') return next()
  // 获取token
  const tokenStr = window.sessionStorage.getItem('token')
  // 没有token, 强制跳转到登录页
  if (!tokenStr) return next('/login')
  next()
})

export default router
